import { Component } from '@angular/core';
import { Activities } from '../../activities/activities';
import { NavMembers } from '../nav-members/nav-members';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

interface NavItem {
  item: number;
  name: string;
  active: boolean;
}

@Component({
  selector: 'app-nav-campaigns',
  imports: [CommonModule, FormsModule, NavMembers, Activities],
  templateUrl: './nav-campaigns.html',
  styleUrl: './nav-campaigns.css'
})
export class NavCampaigns {
  public navItems: NavItem[] = [
    { item: 0, name: 'Miembros de la campaña', active: true },
    { item: 1, name: 'Actividad', active: false }
  ];

  triggerAction(action:number){
    for (let i = 0; i < this.navItems.length; i++) {
      if(i == action){
        this.navItems[i].active = true;
      }else{
        this.navItems[i].active = false;
      }
    }
  }
}
